import BackgroundImage from 'components/BackgroundImageFromAsset/BackgroundImageFromAsset';

BackgroundImage.displayName = 'Section.BackgroundImage';

export default BackgroundImage;
